﻿import { ResultViewModel } from '../../Regelverk/Models/ResultViewModel';

export const getResult = async (kapittelsideGuid: string): Promise<ResultViewModel> => {
    const url = new URL('/api/mt1535/regelverk/getparagrafer', window.location.origin);
    url.searchParams.append('kapittelsideGuid', kapittelsideGuid);

    const response = await fetch(url);

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};